import classnames from 'classnames';
import React from 'react';
import styles from './styles.scss';

// TODO: This component should be renamed as we get more list types.

interface Props {
  children: React.ReactNode;
  className?: string;
}

const CostList = ({ children, className }: Props): JSX.Element => {
  return <ul className={classnames(styles.list, className && className)}>{children}</ul>;
};

export default CostList;
